export const DRIVER_GENDER_OPTIONS = [
  { labelKey: "gender-men", defaultLabel: "Men", value: "Men" },
  { labelKey: "gender-women", defaultLabel: "Women", value: "Women" },
] as const;

export const DRIVER_MARITAL_STATUS_OPTIONS = [
  { labelKey: "marital-single", defaultLabel: "Single", value: "Single" },
  { labelKey: "marital-married", defaultLabel: "Married", value: "Married" },
  { labelKey: "marital-divorced", defaultLabel: "Divorced", value: "Divorced" },
] as const;

export const DRIVER_GENDER_VALUES = DRIVER_GENDER_OPTIONS.map((opt) => opt.value);
export const DRIVER_MARITAL_STATUS_VALUES = DRIVER_MARITAL_STATUS_OPTIONS.map((opt) => opt.value);

export const REQUIRED_DRIVER_DOCUMENTS = [
  { type: "skck", nameKey: "label-document-skck", defaultLabel: "SKCK" },
  { type: "ktp", nameKey: "label-document-ktp", defaultLabel: "KTP" },
  { type: "kk", nameKey: "label-document-kk", defaultLabel: "KK" },
  { type: "sim", nameKey: "label-document-sim", defaultLabel: "SIM" },
  { type: "domicile_letter", nameKey: "label-document-domicile", defaultLabel: "Domicile Letter" },
] as const;
